(function () {

  'use strict';

  function pxAddCloudStorageDialog(
    $filter, toastr, RegexModel, CloudStorageService, $rootScope
  ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        tenant: '=tenant',
        me: '=me',
        meta: '=meta',
        callback: '&callback',
        reposition: '&reposition'
      },
      templateUrl: 'app/components/settings/cloudStorage/addCloudStorage/addCloudStorage.template.html',
      link: function (scope) {

        const regexModel       = new RegexModel();
        scope.illegalNameCheck = regexModel.illegalCharsCheck();
        scope.domainRegex      = regexModel.domainRegex();
        scope.domainSuffix     = regexModel.domainSuffix();
        scope.ipRegex          = regexModel.ipRegex();
        scope.urlRegex         = regexModel.urlRegex();

        scope.providerOptions = {
          listRaw: [
            { id: 'AZURE_BLOB_STORAGE', name: 'AzureBlobStorage', svg: 'app/templates/azureLogo.template.html', cssClass: 'azure_google-icon_075' },
            { id: 'GOOGLE_CLOUD_STORAGE', name: 'GoogleCloudStorage', svg: 'app/templates/googleLogo.template.html', cssClass: 'azure_google-icon_075' },
            { id: 'S3', name: 'AmazonCloudStorage', svg: 'app/templates/aws_logo.template.html', cssClass: 'aws-icon_125' }
          ],
          skipOrderByName: true,
          svgIcon: 'yes',
          selectedItem: { id: 'AZURE_BLOB_STORAGE', name: 'AzureBlobStorage', svg: 'app/templates/azureLogo.template.html', cssClass: 'azure_google-icon_075' },
          simplifiedItemsList: false
        };

        scope.authMethod = {
          type: 'ASSUME_ROLE'
        };

        const authenticationTypes = {
          ASSUME_ROLE: {
            authType: 'ASSUME_ROLE',
            accountId: '',
            externalId: '',
            roleName: ''
          },
          STATIC: {
            authType: 'STATIC',
            accessKey: '',
            secretAccessKey: ''
          }
        };

        scope.ILLEGAL_CHARS = '/:*?"<>';

        scope.documentSourceCaptions = {
          PRINT_ANYWHERE: 'PrintAnywhere',
          PRINT_LATER: 'PrintLater',
          VIA_THE_CLOUD: 'ViaTheCloud',
          CHROME_PRINT: 'ChromePrint',
          MOBILE_PRINT: 'MobilePrint',
          PRINT_CAPTURE: 'PrinterCapture',
          MOBILE_CAPTURE: 'MobileCapture'
        };

        scope.availableDocumentSources = getAvailableDocumentSources(scope.context ? scope.context.info.type : 'AZURE_BLOB_STORAGE');

        scope.storageProvider = scope.context
          ? {
              type: scope.context.info.type,
              name: scope.context.info.name,
              endpointSuffix: scope.context.info.endpointSuffix || '',
              region: scope.context.info.region || '',
              endpointOverride: scope.context.info.endpointOverride || '',
              key: scope.context.info.type === 'S3' ? angular.copy(authenticationTypes[scope.authMethod.type]) : '',
              active: scope.context.info.active,
              documentSources: angular.copy(scope.context.info.docSources),
              sites: scope.context.info.sites || []
            }
          : {
              type: 'AZURE_BLOB_STORAGE',
              name: '',
              endpointSuffix: '',
              region: '',
              endpointOverride: '',
              key: '',
              active: true,
              documentSources: angular.copy(scope.availableDocumentSources),
              sites: []
            };

        scope.changeBlobStorageType = function (item) {
          const selectedType = item.id;
          scope.availableDocumentSources = getAvailableDocumentSources(selectedType);
          scope.storageProvider = {
            type: selectedType,
            name: '',
            endpointSuffix: '',
            region: '',
            endpointOverride: '',
            key: selectedType === 'S3' ? angular.copy(authenticationTypes[scope.authMethod.type]) : '',
            active: true,
            documentSources: angular.copy(scope.availableDocumentSources),
            sites: []
          };
          scope.reposition();
        };

        scope.changeS3AuthMethod = function () {
          scope.storageProvider.key = angular.copy(authenticationTypes[scope.authMethod.type]);
        };

        scope.connectCloudStorage = function () {
          if (!scope.saving) {
            scope.saving = true;
            CloudStorageService.connectCloudStorage(scope.storageProvider).then(() => {
              toastr.success($filter('translate')('ChangesSaved'));
              scope.callback();
              scope.saving = false;
            }).catch((error) => {
              if (error.data.statusCode === 400) {
                handleError(error);
              } else {
                toastr.error($filter('translate')('Error'));
                scope.callback();
              }
              scope.saving = false;
            });
          }
        };

        function handleError(error) {
          switch (error.data.errorCode) {
            case 'CLOUD_STORE_CONNECTION_EXCEPTION':
              error.data.manualLink = 'https://docshield.tungstenautomation.com/Printix/en_US/help/admin/Printix_admin/t_settings_cloud_storage.html#add_cloud_storage';
              break;
          }

          $rootScope.$broadcast('REQUEST_ERROR_HELP', { error });
        };

        function modifyConfiguration(storageProvider) {
          if (!scope.saving) {
            scope.saving = true;
            const modifiedStorageProvider           = angular.copy(scope.context);
            modifiedStorageProvider.info.sites      = storageProvider.sites;
            modifiedStorageProvider.info.active     = storageProvider.active;
            modifiedStorageProvider.info.docSources = storageProvider.documentSources;
            scope.context.saveChanges(modifiedStorageProvider).then(function () {
              toastr.success($filter('translate')('ChangesSaved'));
              scope.callback();
              scope.saving = false;
            }).catch(function () {
              toastr.error($filter('translate')('Error'));
              scope.callback();
              scope.saving = false;
            });
          }
        };

        function modifyCloudStorageKey(storageProvider) {
          if (!scope.saving) {
            scope.saving = true;
            scope.context.changeKey(storageProvider.key).then(function (cloudStorage) {
              toastr.success($filter('translate')('ChangesSaved'));
              scope.callback();
              $rootScope.$broadcast('TEST_CLOUD_STORAGE', { cloudstorage: cloudStorage });
              scope.saving = false;
            }).catch(function () {
              toastr.error($filter('translate')('Error'));
              scope.saving = false;
            });
          }
        };

        function modifyCloudStorageName(storageProvider) {
          if (!scope.saving) {
            scope.saving = true;
            scope.context.changeName(storageProvider.name).then(function (cloudStorage) {
              toastr.success($filter('translate')('ChangesSaved'));
              scope.callback();
              $rootScope.$broadcast('TEST_CLOUD_STORAGE', { cloudstorage: cloudStorage });
              scope.saving = false;
            }).catch(function () {
              toastr.error($filter('translate')('Error'));
              scope.saving = false;
            });
          }
        }

        function modifyCloudStorageDetails(storageProvider) {
          if (!scope.saving) {
            scope.saving = true;
            const modifiedStorageProvider                 = angular.copy(scope.context);
            modifiedStorageProvider.info.name             = storageProvider.name;
            modifiedStorageProvider.info.region           = storageProvider.region;
            modifiedStorageProvider.info.endpointOverride = storageProvider.endpointOverride;
            scope.context.saveChanges(modifiedStorageProvider).then(function (cloudStorage) {
              toastr.success($filter('translate')('ChangesSaved'));
              scope.callback();
              $rootScope.$broadcast('TEST_CLOUD_STORAGE', { cloudstorage: cloudStorage });
              scope.saving = false;
            }).catch(function () {
              toastr.error($filter('translate')('Error'));
              scope.saving = false;
            });
          }
        }

        function modifyCloudStorage(storageProvider) {
          if (storageProvider.type === 'S3') {
            modifyCloudStorageDetails(storageProvider);
          } else {
            modifyCloudStorageName(storageProvider);
          }
        }

        scope.modifyCloudStorage = function (storageProvider, primaryAction, secondaryAction) {
          switch (primaryAction) {
            case 'MODIFY':
              modifyConfiguration(storageProvider);
              break;
            case 'TROUBLESHOOT':
              if (secondaryAction === 'MODIFY_KEY') {
                modifyCloudStorageKey(storageProvider);
              } else if (secondaryAction === 'MODIFY_NAME') {
                modifyCloudStorage(storageProvider);
              }
              break;
          }
        };

        scope.cancelAndExit = function () {
          scope.callback();
        };

        scope.removeDocumentSource = function (documentSource) {
          const index = scope.storageProvider.documentSources.indexOf(documentSource);
          if (index !== -1) {
            scope.storageProvider.documentSources.splice(index, 1);
          }
        };

        scope.openDocumentSourceSelector = function () {
          scope.documentSourceSelectorIsOpen = true;
        };

        scope.onDocumentSourceSelectorDone = function (documentSources) {
          scope.storageProvider.documentSources = documentSources;
          scope.documentSourceSelectorIsOpen = false;
        };

        scope.onDocumentSourceSelectorClose = function () {
          scope.documentSourceSelectorIsOpen = false;
        };

        scope.shouldShowCorsWarning = function () {
          return scope.storageProvider.documentSources.includes('MOBILE_CAPTURE');
        };

        scope.shouldShowDocumentSourceRemovalWarning = function () {
          return scope.context ? scope.context.info.docSources.some(documentSource => !scope.storageProvider.documentSources.includes(documentSource)) : false;
        };

        scope.shouldShowSiteRemovalWarning = function () {
          return scope.context ? (scope.storageProvider.sites.length && scope.context.info.sites.some(siteId => !scope.storageProvider.sites.includes(siteId))) : false;
        };

        scope.openSiteSelector = function () {
          scope.siteSelectorIsOpen = true;
        };

        scope.onSiteSelectorDone = function (siteIds) {
          scope.storageProvider.sites = siteIds;
          scope.siteSelectorIsOpen = false;
        };

        scope.onSiteSelectorClose = function () {
          scope.siteSelectorIsOpen = false;
        };

        function getAvailableDocumentSources(storageType) {
          const documentSources = ['PRINT_ANYWHERE', 'PRINT_LATER', 'VIA_THE_CLOUD', 'CHROME_PRINT', 'MOBILE_PRINT'];
          if (storageType === 'AZURE_BLOB_STORAGE') {
            documentSources.push('PRINT_CAPTURE');
            if (!scope.context ||  scope.context.info.corsPolicy.allowPutBlob) {
              documentSources.push('MOBILE_CAPTURE');
            }
          }
          return documentSources;
        }

      }
    };
  }

  pxAddCloudStorageDialog.$inject = [
    '$filter', 'toastr', 'RegexModel', 'CloudStorageService', '$rootScope'
  ];

  angular
    .module('printix-admin')
    .directive('pxAddCloudStorageDialog', pxAddCloudStorageDialog);

})();
